import React from 'react';

import { InjectedStyledComponent } from '../../../../shared/InjectedStyledComponent.js';
import { FACT_CATEGORY_KEY, FACT_COMPONENT_KEY } from '../Fact.meta.js';
import { IValueTextProps } from '../models/IValueTextProps.js';

// eslint-disable-next-line @typescript-eslint/naming-convention
const ValueText = (props: IValueTextProps) => {
	const { className, children = '' } = props;
	// eslint-disable-next-line @typescript-eslint/naming-convention
	const dangerouslySetInnerHTML = { __html: children };
	return <div className={className} dangerouslySetInnerHTML={dangerouslySetInnerHTML} />;
};

export default InjectedStyledComponent(ValueText, FACT_CATEGORY_KEY, FACT_COMPONENT_KEY, ['valueText']);
